// extracted by mini-css-extract-plugin
export default {"text":"ShareObservation_text__0UM-U","sujet":"ShareObservation_sujet__WtcI7","Textarea":"ShareObservation_Textarea__iw0Jx"};